import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'
Vue.use(Router)
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export const constantRoutes = [
  {
    path: '/login',
    name:'login',
    component: Layout,
    redirect: '/login/index',
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/login'),
        meta: { title: '登录' },
      },
    ],
  },
  {
    path: '/contactUs',
    component: Layout,
    redirect: '/contactUs/contactUsInfo',
    children: [
      {
        path: 'contactUsInfo',
        name: 'contactUsInfo',
        component: () => import('@/views/home/contactUs'),
        meta: { title: '联系我们' },
      },
    ],
  },
  {
    path: '/',
    component: Layout,
    redirect: '/homeCenter/notice',
    children: [
      {
        path: 'homeCenter',
        name: 'homeCenter',
        redirect: '/homeCenter/notice',
        component: () => import('@/views/home'),
        children: [
          {
            path: 'notice',
            name: 'notice',
            component: () => import('@/views/notice'),
          },
          {
            path: 'resultsQuery',
            name: 'resultsQuery',
            component: () => import('@/views/resultsQuery'),
            mete:{title:'成绩查询'}
          },
          {
            path: 'resultQueryInfo',
            name: 'resultQueryInfo',
            component: () => import('@/views/resultsQuery/resultQueryInfo'),
            mete:{title:'学习记录'}
          },
          {
            path: 'signUp',
            name: 'signUp',
            component: () => import('@/views/signUp'),
            mete:{title:'机构报名'}
          },
          {
            path: 'signUpList',
            name: 'signUpList',
            component: () => import('@/views/signUp/signUpList'),
            mete:{title:'报名记录'}
          },
          {
            path: 'userSetting',
            name: 'userSetting',
            component: () => import('@/views/userSetting'),
            mete:{title:'个人设置'}
          },
          {
            path: 'myNotice',
            name: 'myNotice',
            component: () => import('@/views/notice/myNotice'),
            mete:{title:'我的通知'}
          },
        ],
      },
      {
        path: 'signUpInfo',
        name: 'signUpInfo',
        component: () => import('@/views/signUp/signUpInfo'),
        mete:{title:'立即报名'}
      },
      {
        path: 'confirmOrder',
        name: 'confirmOrder',
        component: () => import('@/views/signUp/confirmOrder'),
        mete:{title:'订单支付'}
      },
      {
        path: 'noticeInfo',
        name: 'noticeInfo',
        component: () => import('@/views/notice/noticeInfo'),
        mete:{title:'文章详情'}
      },
      {
        path: 'courseDetails',
        name: 'courseDetails',
        component: () => import('@/views/signUp/courseDetails'),
        mete:{title:'课程详情'}
      },
    ],
  },
]

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  })

const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
